var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcViewFavourite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icViewFavourite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.4574591,648.376395 C57.9495438,647.895853 58.1232502,647.190591 57.910998,646.534987 C57.6982452,645.879384 57.1440867,645.411382 56.4632777,645.312064 L50.4100847,644.430736 C50.1522783,644.393115 49.9295136,644.231096 49.8143768,643.996844 L47.108161,638.501212 C46.8042999,637.883731 46.187567,637.5 45.5002503,637.5 C44.8134342,637.5 44.1967013,637.883731 43.8928402,638.501212 L41.1861238,643.997346 C41.070987,644.231597 40.8477217,644.393617 40.5899153,644.431238 L34.5367223,645.312565 C33.8564139,645.411382 33.3017548,645.879885 33.089002,646.535489 C32.8767498,647.191092 33.0504562,647.896355 33.5425409,648.376897 L37.9222453,652.654621 C38.1089672,652.837207 38.194569,653.10005 38.1505166,653.356874 L37.1172888,659.397254 C37.02568,659.92896 37.1648453,660.446119 37.5082534,660.853927 C38.0418875,661.489466 38.9734945,661.683087 39.7183797,661.290829 L45.1318125,658.438678 C45.3580814,658.319797 45.6429198,658.3208 45.8686881,658.438678 L51.2826215,661.290829 C51.5459344,661.429775 51.8267681,661.5 52.1166125,661.5 C52.6457413,661.5 53.1473373,661.264244 53.4922472,660.853927 C53.8361559,660.446119 53.9748206,659.927956 53.8832118,659.397254 L52.8494834,653.356874 C52.805431,653.099549 52.8910328,652.837207 53.0777547,652.654621 L57.4574591,648.376395 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Likes-Swipe-Copy",
    transform: "translate(-33.000000, -637.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icViewFavourite",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewFavourite);
export default __webpack_public_path__ + "static/media/icViewFavourite.3efaf657ed8c5d1f815a4fca4d04d1a4.svg";
export { ForwardRef as ReactComponent };